export default "__VITE_ASSET__BuIu2q3S__"